import { render, staticRenderFns } from "./memberItem.vue?vue&type=template&id=0b3c9941&scoped=true"
import script from "./memberItem.vue?vue&type=script&lang=js"
export * from "./memberItem.vue?vue&type=script&lang=js"
import style0 from "./memberItem.vue?vue&type=style&index=0&id=0b3c9941&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3c9941",
  null
  
)

export default component.exports